export class ARInvoiceList {
    Id: string;
    Tenant: number;
    InvoiceNumber: string;
    InvoiceDate: Date;
    DueDate: Date;
    InvoiceCurrencyCode: string;
    AmountDue: number;
    IsPrinted: boolean;
}